import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { HStack, SectionList } from "native-base";
import { useState } from "react";
import { useWindowDimensions } from "react-native";
import { useTranslation } from "@madmedical/i18n";
import EmptyState from "../../atoms/EmptyState";
import ListHeader from "../../molecules/ListHeader";
import InsulinReminderListItem from "../../molecules/ListItem/InsulinReminderListItem";
const InsulinReminderContentMobile = ({ sections, onDeletePress, onEditPress, }) => {
    const [flatListPosition, setFlatListPosition] = useState(0);
    const screenHeight = useWindowDimensions().height;
    const { t } = useTranslation();
    return (_jsx(SectionList, { onLayout: (event) => {
            setFlatListPosition(event.nativeEvent.layout.y);
        }, maxHeight: Math.floor(screenHeight - flatListPosition - 230), width: "full", minWidth: "full", showsVerticalScrollIndicator: false, sections: sections, renderSectionHeader: ({ section: { header } }) => {
            const { title, badge } = header;
            if (badge === 0) {
                return (_jsxs(_Fragment, { children: [_jsx(ListHeader, { title: title + "alma", badge: badge }), _jsx(HStack, Object.assign({ bgColor: "white", px: 4, py: 5.5, width: "full" }, { children: _jsx(EmptyState, { title: t("measures:noData"), message: t("measures:tryAgainOrSetupAnotherReminder"), my: 4, mx: 5 }) }))] }));
            }
            return _jsx(ListHeader, { title: title, badge: badge });
        }, renderItem: ({ item }) => (_jsx(_Fragment, { children: _jsx(InsulinReminderListItem, Object.assign({}, item, { onDeletePress: onDeletePress, onEditPress: onEditPress })) })), keyExtractor: (item, index) => `section-list-item-${index}`, stickySectionHeadersEnabled: true }));
};
export default InsulinReminderContentMobile;
